export default __webpack_public_path__ + "static/media/CV_BODY.7ebd01da.pdf";